const modernizer = require('./modernizr.js');
const slider = require('./frontpage.js');
const cloudImages = require('./cloudinary.js');
const heroImage = require('./heroImages.js');
const policyExchangeImages = require('./policyExchangeImages.js');
const contactInfo = require('./contactInfo.js');
// const sponsorSlider = require('./sponsorSlider.js');
// const mobileNavbar = require('./mobileNavbar.js');
const navbar = require('./navbar.js');
const ads = require('./ads/ads');

modernizer();
slider();
cloudImages();
heroImage();
policyExchangeImages();
contactInfo();
// mobileNavbar();
ads();

navbar();

jQuery('#donors').slick({
  speed: 10000,
  autoplay: true,
  autoplaySpeed: 0,
  cssEase: 'linear',
  slidesToShow: 1,
  slidesToScroll: 1,
  variableWidth: true,
  arrows: false,
  //prevArrow: '<button class="slick-prev"><img src="./wp-content/themes/i2icenter/img/left.png" /></button>',
  //nextArrow: '<button class="slick-next"><img src="./wp-content/themes/i2icenter/img/left.png" /></button>',
});

jQuery('#sponsors').slick({
  speed: 10000,
  autoplay: true,
  autoplaySpeed: 0,
  cssEase: 'linear',
  slidesToShow: 1,
  slidesToScroll: 1,
  variableWidth: true,
  arrows: false,
  //prevArrow: '<button class="slick-prev"><img src="./wp-content/themes/i2icenter/img/left.png" /></button>',
  //nextArrow: '<button class="slick-next"><img src="./wp-content/themes/i2icenter/img/left.png" /></button>',
});

jQuery('.slick-prev').appendTo('#donors');
jQuery('.slick-prev').appendTo('#sponsors');

function addPlaceholder() {

  if ( jQuery('#email_address_0').length) {
    jQuery('#email_address_0').attr('placeholder', 'Enter Your Email Address');
  }
  else {
    setTimeout(addPlaceholder, 100);
  }
}

jQuery(document).ready(addPlaceholder);




document.getElementById('navbarToggler').onclick = function () {

  var heightChange = (document.querySelectorAll('.menu-item').length * 33) + 36;
  var menu = document.getElementById('mainMenu');

  if (this.classList.contains('open')) {

    this.classList.remove('open');
    menu.classList.remove('show');

  } else {

    this.classList.add('open');
    menu.classList.add('show');

  }

}
